import {createAction, createReducer} from 'redux-act'
import { translatedConfigSelector as configSelector } from '~/config'
import { select, apply, put, takeEvery } from 'redux-saga/effects'
import { get } from 'lodash'
import { all } from 'redux-saga/effects'
import { Entity, handleError } from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'shopShippingMethod';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = {
  ...entity.actions,
  shippingMethodAction: {
    request: createAction('shipping method action request', (actionUrl, params, itemName='shipments') => ({actionUrl, params, itemName})),
    failure: createAction('shipping method action failure', (message) => ({message})),
    success: createAction('shipping method action success', (data) => ({data}))
  },
};

export const TYPE_ROUTES = {
  'SmartPostParcelMethod': 'shop-smartpost-parcel',
  'OmnivaParcelMethod': 'shop-omniva-parcel',
  'DPDParcelMethod': 'shop-dpd-parcel',
  'FlatFeeMethod': 'shop-flat-fee-methods',
  'ShopPakipointMethod': 'shop-pakipoint',
  'CustomMethod': 'shop-custom-methods',
};

// WORKERS
export const workers = {
  ...entity.workers,
  * createShopShippingMethod(action) {
    const { route, data } = get(action, 'payload', {});

    try {
      const config = yield select(configSelector);
      const api = new API(config);
      const response = yield apply(api, api.callRoute, [`${route}/`, 'POST', data]);

      yield put(actions.create.success(response.data));

      return response.data;
    } catch (e) {
      handleError(e, actions.create);
      throw e;
    }
  },
  * shippingMethodAction(action) {
    const { actionUrl, params, itemName } = get(action, 'payload', {});

    try {
      const config = yield select(configSelector);
      const api = new API(config);
      const response = yield apply(api, api.call, [actionUrl, 'GET', null, params]);

      yield put(actions.shippingMethodAction.success({[itemName]: response.data}));
      return response.data;
    } catch (e) {
      handleError(e, actions.shippingMethodAction);
      throw e;
    }
  },
};

// SAGA
export function * saga() {
  yield all([
    ...entity.saga,
    takeEvery(actions.shippingMethodAction.request().type, workers.shippingMethodAction)
  ]);
}

export const reducer = createReducer(entity.reducer, {});

export default {
  actions,
  workers,
  saga,
  reducer
}
